import { StorefrontModule } from '@vue-storefront/core/lib/modules';
import { productAlertsStore } from './store'

export const ProductAlertsModule: StorefrontModule = async function ({ store, router }) {
  store.registerModule('productAlerts', productAlertsStore)
}
